import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Observable';

import { StorageService } from "./storage.service";
import { ApiService } from "../../shared/services/api.service";
import { Subject } from 'rxjs';
import Cookies from 'js-cookie';

@Injectable()
export class AuthService {
  geturl: any = window.location.href;
  url = new URL(this.geturl);
  ssoToken: any;
  loginEmpId: any;
  buId: any;
  getClient: any;
  vendorGuid: any;
  empGuid: any;
  role: any;
  etsBuid: any;

  constructor(
    private storageService: StorageService,
    private apiService: ApiService,
       ) {
        if (this.url.searchParams.get("etsBuid") || this.url.searchParams.get("buid")){
          this.storageService.clearStorage();
        }
        this.buId = this.url.searchParams.get("buid") || this.storageService.getLocalStorage('bu_id');
        this.getClient = this.url.searchParams.get("client") || this.storageService.getLocalStorage('client');
        this.vendorGuid = this.url.searchParams.get("vendorGuid") || this.storageService.getLocalStorage('vendorGuid');
        this.empGuid = this.url.searchParams.get("guid") || this.storageService.getLocalStorage('employee_guid');
        this.role = this.url.searchParams.get("role") || this.storageService.getLocalStorage('role');
        this.etsBuid = this.url.searchParams.get("etsBuid") || this.url.searchParams.get("buid") || this.storageService.getLocalStorage('etsBuid') || this.storageService.getLocalStorage('bu_id');
       }

    public user: any = {};
    public client: any = {};
    private userInfoFetchObservable: Observable<any>;
    public isLoginDone$ = new Subject();
    public serverTime: string;

    public setloginInfoSubject(value) {
      this.isLoginDone$.next(value);
    }
    checkAuthCookies(){
      if (this.ssoToken == undefined){
        return;
      }

      const userInfo = {
        ssoToken: this.ssoToken,
        vendorGuid: this.vendorGuid,
        empGuid: this.empGuid,
        buid: this.buId,
        role: this.role,
        loginEmpId: this.loginEmpId,
        etsBuid: this.etsBuid
      };
      this.setUserInfo(userInfo);
    }

    public isAuthenticated() {
      this.loginEmpId = Cookies.get('loginEmail-' + this.etsBuid, { domain: 'moveinsync.com' } );
      this.ssoToken = Cookies.get('sso-wis-token-' + this.etsBuid , { domain: 'moveinsync.com' });
      if (this.ssoToken != undefined) {
        this.checkAuthCookies();
      }
      const tokenInfo = this.storageService.getLocalStorage('token');
      if (tokenInfo
      && this.storageService.getLocalStorage('employee_guid')
      &&  this.storageService.getLocalStorage('bu_id') && !this.ssoToken
     ) {
        return true;
      }else if (this.ssoToken){
        return true;
      }
      return false;
    }

    public userLogout() {
      this.clearAllCookies();
      this.storageService.clearStorage();
      this.user = {};
    }

    clearAllCookies() {
      const cookies = document.cookie.split("; ");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=moveinsync.com";
      }
    }

    public init() {
      const tokenInfo = this.storageService.getLocalStorage('token');
      if (tokenInfo && !this.ssoToken) {
        this.user = {...this.user,
          buId: this.storageService.getLocalStorage('bu_id'),
          employeeGuid: this.storageService.getLocalStorage('employee_guid'),
          role: this.storageService.getLocalStorage('role'),
          vendorGuid: this.storageService.getLocalStorage('vendorGuid'),
          loginEmpId: this.storageService.getLocalStorage('loginEmpId')
        };
        this.apiService.setUser(this.user);
        this.client = {
          client: this.storageService.getLocalStorage('client'),
        };

      }else{
        this.user = {...this.user,
          buId: this.buId,
          employeeGuid: this.url.searchParams.get("guid") || this.storageService.getLocalStorage('employee_guid'),
          role: this.url.searchParams.get("role") || this.storageService.getLocalStorage('role'),
          vendorGuid: this.url.searchParams.get("vendorGuid") || this.storageService.getLocalStorage('vendorGuid'),
          loginEmpId :  this.url.searchParams.get("loginEmpId") || this.storageService.getLocalStorage('loginEmpId'),
          etsBuid: this.url.searchParams.get("etsBuid") || this.storageService.getLocalStorage('etsBuid')
        };
        this.apiService.setUser(this.user);
        this.client = {
          client: this.url.searchParams.get("client") || this.storageService.getLocalStorage('client'),
        };
      }


      if (this.client.client) { this.apiService.setClient(this.client); }
    }

    public setUserInfo(userInfo: any) {
      if (this.ssoToken){
        this.storageService.setLocalStorage('sstoken', userInfo.ssoToken);
        this.storageService.setLocalStorage('vendorGuid', userInfo.vendorGuid);
        this.storageService.setLocalStorage('employee_guid', userInfo.empGuid);
        this.storageService.setLocalStorage('bu_id', userInfo.buid);
        this.storageService.setLocalStorage('role', userInfo.role);
        this.storageService.setLocalStorage('client', this.getClient);
        this.storageService.setLocalStorage('loginEmpId', this.loginEmpId);
        this.storageService.setLocalStorage('loginEmpId', this.loginEmpId);
        this.storageService.setLocalStorage('etsBuid', userInfo.etsBuid);
        this.init();
      }else{
        this.storageService.setLocalStorage('token', userInfo.token);
        this.storageService.setLocalStorage('vendorGuid', userInfo.vendorGuid);
        this.storageService.setLocalStorage('employee_guid', userInfo.empGuid);
        this.storageService.setLocalStorage('bu_id', userInfo.buid);
        this.storageService.setLocalStorage('role', userInfo.role);
        this.storageService.setLocalStorage('loginEmpId', this.loginEmpId);
        this.init();
      }
    }

    public getServerTime(searchQuery: any) {
      return this.apiService.httpRequest({
        url: 'getServerTime',
        type: 'GET',
        queryParams: searchQuery
      });
    }

    public setClientInfo(client: any) {
      this.client = client;
      this.storageService.setLocalStorage('client', client.client);
      this.apiService.setClient(this.client);
    }
    public getUserInfo(): Observable<any> {
      return new Observable(observer => {
        if (this.user.info) {
          observer.next(this.user.info);
          observer.complete();
        } else {
          this.apiService.httpRequest({
            url: 'fetchEmployee',
            type: 'GET'
          }).subscribe((response) => {
            this.user.info = response;
            observer.next(this.user.info);
            observer.complete();
          });
        }
      });
    }

    getUser(){
      return this.user?.info;
    }
    // public getUserInfo(): Observable<any> {
    //   if (this.user.info) {
    //     return new Observable(observer => {
    //       observer.next(this.user.info);
    //       observer.complete();
    //     });
    //   } else {
    //     if (!this.userInfoFetchObservable) {
    //       this.userInfoFetchObservable = new Observable(observer => {
    //         const httpRequest = this.apiService.httpRequest({
    //           url: 'fetchEmployee',
    //           type: 'GET'
    //         });
    //         httpRequest.subscribe((response) => {
    //           this.user.info = response;
    //           observer.next(this.user.info);
    //           observer.complete();
    //         });
    //       });
    //     }
    //     return this.userInfoFetchObservable;
    //   }
    // }

    public isUserVendor() {
      return (this.user.role === 'VENDOR_MANAGER' || this.user.role === 'vendormgr' );
    }

    public getClientBuid(queryParams) {
      return this.apiService.httpRequest({
        url: 'getClientBuid',
        type: 'GET',
        queryParams
      });
    }
  public setPolicyCookie(){
    this.storageService.setLocalStorage('companyPolicy', 'true');
  }
}
